import { render, staticRenderFns } from "./GymVideoPlayer.vue?vue&type=template&id=697afe8d&scoped=true"
import script from "./GymVideoPlayer.vue?vue&type=script&lang=js"
export * from "./GymVideoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697afe8d",
  null
  
)

export default component.exports